import React, { useState } from 'react';
import { emailService } from './utils/emailService';

const branchLocations = [
  {
    city: 'Bengaluru (KA)',
    address: 'Dinne Circle, Chikkanayakanahalli C.L. Road, Carmelram Post, Bengaluru - 560035.'
  },
  //{
  //city: 'Hyderabad (TG)',
  //address: 'Plot No. 58, Guttala Begumpet, Madhapur Road, Hyderabad - 500081.'
  // },
  // {
  //   city: 'Mumbai (MH)',
  //   address: 'Contact via email for specific address details.'
  // },
  // {
  //   city: 'Ahmedabad (GJ)',
  //   address: 'Contact via email for specific address details.'
  // },
  // {
  //   city: 'Jodhpur (RJ)',
  //   address: 'Contact via email for specific address details.'
  // },
];

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  
  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');
    console.log(form);
    try {
      const result = await emailService.sendContactEmail(form);
      
      if (result.success) {
        setSubmitMessage('Message sent successfully! We will get back to you soon.');
        setForm({ name: '', email: '', phone: '', message: '' }); // Reset form
      } else {
        setSubmitMessage('Failed to send message. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-blue-100 via-white to-red-100 overflow-x-hidden">
      <section className="w-full py-12 md:py-20 px-4 md:px-0 max-w-6xl mx-auto flex flex-col md:flex-row gap-12 items-start">
        {/* Left: Locations & Contact Info */}
        <div className="flex-1 flex flex-col gap-8">
          <div className="bg-white/90 backdrop-blur rounded-2xl shadow-lg p-8">
            <h2 className="text-3xl font-bold text-blue-700 mb-4 flex items-center gap-2">
              <span role="img" aria-label="location">📍</span> Branch Locations
            </h2>
            <ul className="space-y-4">
              {branchLocations.map((loc, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="text-2xl mt-1">📍</span>
                  <div>
                    <div className="font-semibold text-blue-800">{loc.city}</div>
                    <div className="text-gray-700 text-base">{loc.address}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-white/90 backdrop-blur rounded-2xl shadow-lg p-8 mt-4">
            <h2 className="text-2xl font-bold text-blue-700 mb-2 flex items-center gap-2">
              <span role="img" aria-label="email">📧</span> Contact Information
            </h2>
            <div className="text-lg text-gray-700">
              Email: <a href="mailto:info@avaluecapital.com" className="text-red-500 underline">info@avaluecapital.com</a>
            </div>
          </div>
          <div className="bg-white/90 backdrop-blur rounded-2xl shadow-lg p-4 mt-4">
            <h2 className="text-2xl font-bold text-blue-700 mb-2 flex items-center gap-2">
              <span role="img" aria-label="map">🗺️</span> Find Us
            </h2>
            <div className="w-full h-64 rounded-lg overflow-hidden">
             <iframe
                title="Avalue Capital Bengaluru Location"
                src="https://www.google.com/maps?q= +Dinne +Circle, +Chikkanayakanahalli +C.L. +Road, +Carmelram +Post, +Bengaluru +-+560035.&output=embed"
               width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
        {/* Right: Contact Form */}
        <div className="flex-1 flex flex-col justify-center bg-white/90 backdrop-blur rounded-2xl shadow-2xl p-8">
          <h2 className="text-3xl font-bold mb-6 text-blue-700 text-center">Send us a Message</h2>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4 w-full max-w-md mx-auto">
            <input type="text" name="name" placeholder="Name" className="border border-blue-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-400 text-lg" value={form.name} onChange={handleChange} required />
            <input type="email" name="email" placeholder="Email" className="border border-blue-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-400 text-lg" value={form.email} onChange={handleChange} required />
            <input type="tel" name="phone" placeholder="Phone" className="border border-blue-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-400 text-lg" value={form.phone} onChange={handleChange} required />
            <textarea name="message" placeholder="Message" rows="4" className="border border-blue-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-400 text-lg resize-none" value={form.message} onChange={handleChange} required></textarea>
            <button type="submit" className="bg-gradient-to-r from-blue-500 to-red-500 hover:from-blue-600 hover:to-red-600 text-white px-8 py-3 rounded-full font-semibold shadow-lg transition text-lg mt-2" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
            {submitMessage && (
              <div className={`text-center font-semibold mt-2 ${submitMessage.includes('successfully') ? 'text-green-600' : 'text-red-600'}`}>
                {submitMessage}
              </div>
            )}
          </form>
        </div>
      </section>
    </div>
  );
};

export default ContactPage; 
